module.exports = __webpack_public_path__ + "img/mini-logo.08cc9246.png";